module.exports = __webpack_public_path__ + "img/arcade.dcee9c93.png";